export const ALPHA_VOICE_COLOURS = {
  primary: '#1b3670',
  accentLight: '#6ec6ff',
  accent: '#2196f3',
  accentDark: '#0069c0',
} as const;

export default ALPHA_VOICE_COLOURS;
